import React, { useState } from "react"
import { useSelector } from "react-redux"
import CopyIcon from '../../../../assests/learning-tracking/lesson/copy.png'
import DeleteIcon from '../../../../assests/learning-tracking/lesson/delete.png'
import EditIcon from '../../../../assests/learning-tracking/lesson/edit-icon-highlight.png'
import AuthorIcon from '../../../../assests/ContentBank/Author.png'
import DownloadIcon from '../../../../assests/ContentBank/download.png'
import RestoreIcon from '../../../../assests/ContentBank/restore.png'
import LikeIcon from '../../../../assests/ContentBank/like.png';
import DisIcon from '../../../../assests/ContentBank/dis.png';
import FavoriteIcon from '../../../../assests/ContentBank/favorite.png';
import NotFavoriteIcon from '../../../../assests/ContentBank/not-favorite.png';
import classes from './ProjectPopup.module.css'
import AuthorLevelPopup from "./AuthorLevelPopup"
import { onKeyDown } from "../../../../service"
import DynamicMessage from '../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage';
import { DynamicMessageTypeEnum } from "../../../lms-shared/models/DynamicMessageTypeEnum"

const ProjectPopup = ({ ideIcon, material, close, showPopup, getAuthorName, handleEditName, handleDelete, handleCopy, handleForward, handleDownload, handleRestore }) => {

    const texts = useSelector(state => state.translate.texts);
    const { user } = useSelector(state => state.auth);

    const [messagePopup, setMessagePopup] = useState()
    const [isEditName, setIsEditName] = useState(false)

    function deleteFunc(e) {
        e.stopPropagation()
        setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Warn} cancelFunc={(e) => closeMessage(e)} confirmFunc={(e) => handleDelete(e, material.id, showPopup, close, setMessagePopup)} content={texts.MessageContentDeleteItem} />)
    }

    function restoreProject(e) {
        e.stopPropagation()
        setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Warn} cancelFunc={(e) => closeMessage(e)} confirmFunc={(e) => handleRestore(e, material.id, showPopup, close, setMessagePopup)} content={texts.MessageContentRestoreProjectWarn} />)
    }

    function closeMessage(e) {
        e.stopPropagation()
        setMessagePopup(false)
    }

    const handleSetIsEditName = (e) => {
        e.stopPropagation()
        setIsEditName(!isEditName)
    }

    const isMyMaterial = (e) => {
        return !material.user || user.id === material.user.id;
    }

    return (
        <div className={classes.ProjectPopupContainer}>
            {material && <>
                <div className={classes.HeaderContainer}>
                    <div className={classes.AuthorWrapper}>
                        <img src={AuthorIcon} alt='AuthorIcon' />
                        <div className={classes.Author}>{texts.author} {getAuthorName()}</div>
                        {/* <AuthorLevelPopup {...material} fromPopup={true} /> */}
                    </div>
                    {/* <div className={classes.More}>
                        <div className={classes.Like}>
                            <div className={classes.NumLikes}>{material.likes || null}</div>
                            <img src={material.iLike ? LikeIcon : DisIcon} onClick={e => addReaction(e, ContentReactionEnum.Like)} />
                        </div>
                        <img src={!material.iFavorite ? FavoriteIcon : NotFavoriteIcon} onClick={e => addReaction(e, ContentReactionEnum.Favorite)} />
                    </div> */}
                </div>
                <div className={classes.BGImgWrapper}>
                    {material.thumbnail && <img className={classes.BGImg} src={material.thumbnail} alt="thumbnail" />}
                    {ideIcon && <img className={classes.DescriptionImg} src={ideIcon} alt="IdeIcon" />}
                </div>
                <div className={classes.DescriptionContainer}>
                    {!isEditName ? <div className={classes.MaterialName} title={material.name}>{material.name}</div> :
                        <input
                            type='text'
                            defaultValue={material.name}
                            name="newProjectName"
                            className={classes.ProjectNameInput}
                            onClick={(e) => e.stopPropagation()}
                            onKeyDown={e => onKeyDown(e, () => e.stopPropagation())}
                            onBlur={(e) => handleEditName(e, material.id, e.target.value, setIsEditName)}
                        ></input>
                    }
                    <div className={classes.MaterialDesc}>{material.description ? material.description : texts.noDescription}</div>
                </div>
                <div className={classes.Line}></div>
                <div className={classes.MoreInfo}>{material.moreInfo ? material.moreInfo : texts.noMoreInfo}</div>
                <div className={classes.ActionsContainer}>
                    {isMyMaterial() && handleEditName && <img className={classes.Img} src={EditIcon} alt="Edit" onClick={(e) => handleSetIsEditName(e, setIsEditName)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleSetIsEditName(e, setIsEditName))} />}
                    {handleCopy && <img className={classes.Img} src={CopyIcon} alt="Copy" onClick={(e) => handleCopy(e, material.id, showPopup, close)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCopy(e, material.id, showPopup, close))} />}
                    {isMyMaterial() && handleDelete && <img className={classes.Img} alt="Delete" src={DeleteIcon} onClick={(e) => deleteFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => deleteFunc(e))} />}
                    {handleDownload && <img className={classes.Img} src={DownloadIcon} alt="Download" onClick={(e) => handleDownload(e, material)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleDownload(e, material))} />}
                    {handleForward && handleForward}
                    {handleRestore && <img className={classes.Img} src={RestoreIcon} alt="Restore" onClick={(e) => restoreProject(e, material)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => restoreProject(e, material))} />}
                </div>
                {messagePopup}
            </>}
        </div >
    )
}

export default ProjectPopup